module.exports = __webpack_public_path__ + "static/media/file-earmark.3777f0ed.svg";